<template>
    <div class="top-1">
        <div class="top-item">
            <div class="label">累计申请金额</div>
            <div class="value">{{BankObj?.cumulativeSuperviseAmount}}{{ BankObj?.cumulativeSuperviseAmountCheckY==1?'万':'亿'}}</div>
        </div>

        <div class="top-item">
            <div class="label">累计放贷金额</div>
            <div class="value">{{BankObj?.cumulativeSuperviseAmountReceive}}{{ BankObj?.cumulativeSuperviseAmountReceiveCheckY==1?'万':'亿'}}</div>
        </div>

        <div class="top-item">
            <div class="label">累计还款金额</div>
            <div class="value">{{BankObj?.cumulativeRepaymentAmount}}{{ BankObj?.cumulativeRepaymentAmountCheckY==1?'万':'亿'}}</div>
        </div>

        <div class="top-item">
            <div class="label">执行中贷款笔数/ 金额</div>
            <div class="value">{{BankObj?.inSuperviseCount}}/{{ BankObj?.inSuperviseAmount }}{{ BankObj?.inSuperviseAmountCheckY==1?'万':'亿'}}</div>
        </div>

        <div class="top-item">
            <div class="label">服务客户</div>
            <div class="value">{{BankObj?.supervisedCount}}家</div>
        </div>

        <div class="top-item">
            <div class="label">{{superviseType==1?'抵押活畜总数':'监管产品总重'}}</div>
            <div class="value">{{superviseType==1?BankObj?.liveCount:(BankObj?.reserveTotalWeight||'0')+'吨'}}</div>
        </div>

        <div class="top-item">
            <div class="label"> {{superviseType==1?'抵押活畜保额总值':'监管产品货值'}}</div>
            <div class="value">{{superviseType==1?BankObj?.superviseInsuranceTotalAmount:BankObj?.mortgageTotalAmount}}{{ superviseType==1?(BankObj?.superviseInsuranceTotalCheckY ==1?'万':'亿'):(BankObj?.mortgageTotalAmountCheckY==1?'万':'亿') }}</div>
        </div>

        <div class="top-item" v-if="superviseType!=4">
            <div class="label">预警信息</div>
            <div class="value">{{BankObj?.waringAllCount}}条 <img src="@/assets/rightModel.png" @click="showDig"></div>
        </div>
        <model v-if="showModel" @close="close">
            <div style="display: flex;">
                <div class="left">
                    <div class="left-header">
                        <div class="left-header-title">
                            <span>预警总数</span>
                            <span style="margin-top: 0.38rem;"><span class="left-header-font">{{BankObj?.waringAllCount}}</span>个</span>

                        </div>
                        <div class="left-header-title">
                            <span>已处理数量</span>
                            <span style="margin-top: 0.38rem;"><span class="left-header-font">{{ BankObj?.waringProcessCount }}</span>个</span>
                        </div>
                    </div>
                <div class="chartF">
                    <div style="width: 100%;height: 100%;" id="chartt"></div>
                </div>

            </div>
                <div class="right">
                    <el-table :data="tableData" style="width: 100%"    height="5.48rem">
                        <el-table-column prop="warnTitle" label="预警标题" min-width="150">
                        </el-table-column>
                        <el-table-column prop="warningStatus" label="预警状态" min-width="150">
                            <template slot-scope="scope">{{ handelStatus(scope.row.warningStatus) }}</template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="发起时间" min-width="150" >
                        </el-table-column>
                    </el-table>
                    <div style="display:flex; justify-content: flex-end;">
                        <el-pagination
                        layout="prev, pager, next"
                        :total="total" 
					@current-change='currentPage'>
                    </el-pagination>
                    </div>       
                </div>
            </div>
           
        </model>
    </div>
</template>
<script>
import model from './model.vue'
export default {
    components: {
        model
    },
    props:{
        BankObj:{
        type:Object,
        default: () => {},
    },
    superviseType:{
            type:Number,
            default:0
        },
        queryParamsData:{
            type:Object,
        default: () => {},
        }
    },
    data() {
        return {
            showModel: false,
            chart: undefined,
            total: 0,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
            },
            tableData:[],
            statusList:[
                {label:'待处理',value:1},
                {label:'运营人员处理中',value:2},
                {label:'已结束',value:3},
            ]
        }
    },
computed:{
    handelStatus(){
        return (val)=>{
            let name=''
            this.statusList.forEach(item=>{
                if(item.value==val){
                    name=item.label
                }
            })
            return name
        }
    }
},
   
    methods: {
        currentPage(value){
            this.queryParams.pageNum=value
            this.getList()
        },
        getList(){
            this.$http({
                url: 'ffsapp-service/superviseProperty/queryWarningDetailStatistics',
			method: 'post',
            data:{
                ancestorsAllQuery:this.queryParamsData?.ancestorsAllQuery,
                superviseType:this.superviseType,
                pageNum:this.queryParams.pageNum,
                pageSize:10
            }
            }).then(res=>{
                if(res.data.code==200){
                    this.tableData=res.data.result.list||[]
                    this.total=Number(res.data.result.total)
                
                }
            })
        },
        setChart() {
            this.chart = this.$echarts.init(document.getElementById('chartt'))
            let option = {

                series: [
                    {
                        color: ["#3AFFFB", "#FFC700", "#165DFF"],
                        name: "牧民资产",
                        type: "pie",
                        radius: ['40%', '70%'],
                        bottom: 10,
                        // itemStyle: {
                        //   borderWidth: 1,
                        //   borderColor: "#fff",
                        // },
                        label: {
                            show: true,
                            position: 'outside',
                            color: '#FFFFFF',
                            padding: [0, -20],
                            alignTo: 'labelLine',
                            formatter: "{d}%\n{b}",
                        },
                        emphasis: {
                            label: {
                                show: true,
                                // fontSize: '40',
                                // fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: true,
                            length: 10,
                            length2: 20,
                            lineStyle: {
                                color: '#73c0de',
                            }
                        },
                        data: [
                            { value: this.BankObj?.manageRiskPercentage, name: "经营风险" },
                            { value: this.BankObj?.moralityRiskPercentage, name: "道德风险" },
                            { value: this.BankObj?.marketRiskPercentage, name: "市场风险" },
                        ],
                        // hoverAnimation: false,
                    },
                ]

            };
            this.chart.setOption(option)
        },
        showDig() {
            this.showModel = true
            this.$nextTick(() => {
                this.setChart()
                this.getList()
            })

        },
        close(value) {
            this.showModel = value
        }
    },
}
</script>
<style scoped lang="scss">
::v-deep .el-table tbody tr:hover>td {
    background-color: rgba(0, 0, 0, 1)!important
}

::v-deep .el-table tbody tr:hover {
    background-color: #000000!important
}

.top-1 {
    width: 100%;
    height: 0.7rem;
    margin-top: 0.375rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    .top-item {
        width: 10%;
        height: 100%;
        // background-color: aqua;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;

        .label {
            font-size: 0.2rem;
            font-family: Source Han Sans, Source Han Sans;
            font-weight: 500;
            color: #ffffff;
        }

        .value {
            font-size: 0.375rem;
            font-family: DIN, DIN;
            font-weight: 700;
            color: #efab44;
        }
    }
}
::v-deep.el-table tr{
    background: #000000;
}
::v-deep.el-table thead{
    color: #EFAB44 !important;

}
::v-deep.el-table{
    background: #000000;
}
::v-deep.el-table .el-table__row .cell{
    font-size: 0.18rem;
    color: #FFFFFF;
    font-family: Source Han Sans, Source Han Sans;
    
}
::v-deep.el-table th.el-table__cell{
    background: #000000 !important;
}
::v-deep.el-table td.el-table__cell{
    border: none;
}
::v-deep.el-table .el-table__cell{
    padding: 0.1rem;
}
::v-deep.el-table th.el-table__cell.is-leaf{
    border: none;
}
::v-deep.el-table::before{
    height: 0;
}
::v-deep.el-pagination .btn-next{
    background:#000000 !important;
}
::v-deep.el-pagination .btn-prev{
    background:#000000 !important;
}

.left {
    width: 6.78rem;

    &-header {
        font-family: Source Han Sans, Source Han Sans;
        width: 4rem;
        font-weight: 500;
        font-size: 0.2rem;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;

        &-title {
            display: flex;
            flex-direction: column;
        }

        &-font {
            font-size: 0.38rem;
            font-family: DIN, DIN;
            color: #EFAB44;
            font-weight: 700;
        }
    }

    .chartF {
        width: 4rem;
        height: 4rem;
    }

}
</style>
<style >
.right .el-pager li{
    background:#000000 !important;
}
</style>
